import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f6754e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Новый пароль", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Подтвердите пароль", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxStringLengthRule = _resolveComponent("DxStringLengthRule")!
  const _component_DxValidator = _resolveComponent("DxValidator")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxCustomRule = _resolveComponent("DxCustomRule")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxButton, {
      text: "Установить пароль",
      hint: "Новый пароль",
      type: "default",
      "styling-mode": "outlined",
      visible: !_ctx.isShow,
      onClick: _ctx.onClick
    }, null, 8, ["visible", "onClick"]),
    (_ctx.isShow)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "DefinePasswordControl-form",
          onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFormSubmit($event)))
        }, [
          _createElementVNode("div", null, [
            _hoisted_1,
            _createVNode(_component_DxTextBox, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Новый пароль...",
              "show-clear-button": true,
              value: _ctx.passwordText,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwordText) = $event)),
              UseSystemPasswordChar: true,
              mode: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxValidator, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxStringLengthRule, {
                      min: 6,
                      message: "Не менее 6 символов"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_2,
            _createVNode(_component_DxTextBox, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Подтвердите пароль...",
              "show-clear-button": true,
              value: _ctx.submitPasswordText,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.submitPasswordText) = $event)),
              mode: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxValidator, { onInitialized: _ctx.onInitialized }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxCustomRule, {
                      "validation-callback": _ctx.validatePasswords,
                      reevaluate: true,
                      message: "Пароли не совпадают"
                    }, null, 8, ["validation-callback"])
                  ]),
                  _: 1
                }, 8, ["onInitialized"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createVNode(_component_DxButton, {
            class: "CreateEditDialog-button",
            text: "Сохранить",
            "use-submit-behavior": true,
            type: "success",
            hint: "Сохранить",
            "styling-mode": "outlined"
          }),
          _createVNode(_component_DxButton, {
            class: "CreateEditDialog-button",
            text: "Отмена",
            type: "default",
            "styling-mode": "outlined",
            hint: "Отмена",
            onClick: _ctx.onCloseClick
          }, null, 8, ["onClick"])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}